module.exports = __webpack_public_path__ + "img/guideline_1.8e6e1793.jpg";